




























































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import {
  ApkDetection,
  ApkDetectionPermissionTag,
  ApkDetectionPermissionDeclaration,
  ApkDetectionNetworkTag,
  ApkDetectionSdkPermissionItem,
  ApkDetectionPermissionTagDetailItem
} from "@/modules/apk/apk.interface";
import { ApkService } from "@/modules/apk/apk.service";
import ReportPage from "@/pages/report.vue";
import { ApkStore } from "@/modules/apk/apk.store";
import _cloneDeep from "lodash/cloneDeep";
import { Utils } from "@/plugins/utils";
import ApkDetectionDeclarationDialog from "@/modules/apk/ApkDetectionDeclarationDialog.vue";
import ApkDetectionNetworkDialog from "@/modules/apk/ApkDetectionNetworkDialog.vue";
import ApkDetectionUploadDialog from "@/modules/apk/ApkDetectionUploadDialog.vue";
import ApkDetectionLogsDialog from "@/modules/apk/ApkDetectionLogsDialog.vue";
import ApkDetectionPermissionUsedDialog from "@/modules/apk/ApkDetectionPermissionUsedDialog.vue";
import ApkDetectionSdkPermissionUsedDialog from "../../../modules/apk/ApkDetectionSdkPermissionUsedDialog.vue";
import MiCollapse from "@/components/MiCollapse.vue";
@Component({
  components: {
    ApkDetectionDeclarationDialog,
    ApkDetectionNetworkDialog,
    ApkDetectionUploadDialog,
    ApkDetectionLogsDialog,
    ApkDetectionPermissionUsedDialog,
    ApkDetectionSdkPermissionUsedDialog,
    MiCollapse
  },
  metaInfo: {
    title: "APK检测报告"
  }
})
export default class extends Vue {
  $refs: {
    logDialog: ApkDetectionLogsDialog;
    uploadDialog: ApkDetectionUploadDialog;
    permissionUsedDialog: ApkDetectionPermissionUsedDialog;
    sdkPermissionUsedDialog: ApkDetectionSdkPermissionUsedDialog;
  };
  @Prop(Boolean) print!: boolean;
  @ApkStore.State curApkDetection!: ApkDetection;
  @ApkStore.Mutation setCurApkDetection: any;
  declaration: ApkDetectionPermissionDeclaration | null = null;
  declarationUpdateLoading: 0;
  tempApkDetection!: ApkDetection;
  loading = false;
  declarationDialog = false;
  uploadDialog = false;
  networkDialog = false;
  reasonDialog = false;
  buttonShow = true;
  otherDangerDialog = false;
  otherDangerText = "";

  get id() {
    return this.$route.params.id;
  }

  get isSuccess() {
    return this.curApkDetection && this.curApkDetection.result === "成功";
  }

  created() {
    this.tempApkDetection = _cloneDeep(this.curApkDetection);
    this.buttonShow = Boolean(this.curApkDetection.apkUrl);
  }

  getPermissionTagLevelItem(level: number) {
    switch (level) {
      case 3:
        return {
          text: "低敏感",
          color: "#27C24C"
        };
      case 2:
        return {
          text: "中度敏感",
          color: "#FF9900"
        };
      case 1:
        return {
          text: "高度敏感",
          color: "#EF5050"
        };
      default:
        return {
          text: "-",
          color: "#bcbcbc"
        };
    }
  }

  getPermissionPromotionElTag(row: ApkDetectionPermissionTag) {
    if (row.hasRule) {
      if (row.isApplyed && !row.isUsed) {
        return {
          text: "申请未使用",
          type: "warning"
        };
      } else if (!row.isApplyed && row.isUsed) {
        return {
          text: "使用未申请",
          type: "danger"
        };
      }
    } else {
      return {
        text: "没有规则",
        type: "warning"
      };
    }
  }

  getPermissionProviderText(slug: string) {
    switch (slug) {
      case "app":
        return "APP自身";
      case "sdk":
        return "SDK";
      case "both":
        return "APP和SDK均使用";
      default:
        return slug;
    }
  }

  onPermissionDeclarationUpadteClick(item: ApkDetectionPermissionDeclaration) {
    this.declaration = item;
  }
  async onPermissionDeclarationSaveClick(
    item: ApkDetectionPermissionDeclaration
  ) {
    if (this.declaration) {
      try {
        this.declarationUpdateLoading++;
        await ApkService.updateApkDeclaration(
          this.curApkDetection.apkPackageName,
          {
            ...this.declaration,
            tag: this.declaration.tag.slug
          }
        );
        this.declaration = null;
        // 更新状态树
        this.setCurApkDetection(this.tempApkDetection);
        // 重新克隆一份
        this.tempApkDetection = _cloneDeep(this.curApkDetection);
      } catch {
        this.$message.error("权限使用场景修改失败, 请重试");
      } finally {
        this.declarationUpdateLoading--;
      }
    }
  }

  onPermissionDeclarationCancelClick(item: ApkDetectionPermissionDeclaration) {
    // 恢复之前的状态
    if (this.declaration) {
      this.tempApkDetection = _cloneDeep(this.curApkDetection);
    }
    this.declaration = null;
  }

  /**
   * 点击下载安装包按钮触发
   */
  onDownloadApkClick() {
    const { apkUrl, apkName } = this.curApkDetection;
    Utils.download(apkUrl, apkName);
  }

  /**
   * 点击下载完整数据包时触发
   */
  onDownloadDataClick() {
    Utils.download(this.curApkDetection.sourceDataUrl);
  }

  goBack() {
    this.$router.push(`${this.$route.query.origin}`);
  }

  onAddNetworkTagNoticeClick() {
    if (this.tempApkDetection.hasSetting) {
      this.$router.push({
        name: "addRule-edit-packageName",
        query: {
          packageName: this.tempApkDetection.apkPackageName,
          id: this.curApkDetection.apkPackageName,
          originId: this.$route.query.id,
          type: this.$route.query.type,
          origin: this.$route.query.origin
        },
        params: {
          packageName: this.tempApkDetection.apkPackageName
        }
      });
    } else {
      this.$router.push({
        name: "addRule-add-packageName",
        query: {
          id: this.curApkDetection.apkPackageName,
          originId: this.$route.query.id,
          type: this.$route.query.type,
          origin: this.$route.query.origin,
          apkPackageName: this.tempApkDetection.apkPackageName,
          apkName: this.tempApkDetection.apkName
        }
      });
    }
  }
  onHandleMessage() {
    this.reasonDialog = true;
  }

  onHandleRoute() {
    let id = this.curApkDetection.apkPackageName;
    let origin = this.$route.query.origin;
    let type = this.$route.query.type;
    let packageName = this.tempApkDetection.apkPackageName;
    let originId = this.$route.query.id;

    this.$router.push(
      `/detect/manual?id=${id}&type=${type}&origin=${origin}&packageName=${packageName}&originId=${originId}`
    );
  }

  onHandleShowDangerDialog(item) {
    this.$refs.uploadDialog.open(item.name);
  }

  onOperationCommand() {
    this.reasonDialog = false;
  }

  onOpenPermissionUsedDialog(info: ApkDetectionPermissionTagDetailItem[]) {
    this.$refs.permissionUsedDialog.open(info);
  }

  onOpenSdkPermissionUsedDialog(info: ApkDetectionPermissionTagDetailItem[]) {
    this.$refs.sdkPermissionUsedDialog.open(info);
  }
  detailDialog(item) {
    this.otherDangerDialog = true;
    this.otherDangerText = item.detail;
  }

  /**
   * 点击下载报告按钮触发
   */
  onGenerate() {
    const parent = this.$parent as ReportPage;
    parent.generateReport();
  }

  openUploadDialog(row: ApkDetectionNetworkTag) {
    this.$refs.uploadDialog.open(row.name);
  }

  openNetworkDialog() {
    this.networkDialog = true;
  }

  onOpenLogDialog() {
    this.$refs.logDialog.open(this.id);
  }

  onBack() {
    this.$router.push("/");
  }
}
